// Only grids use the DevExtreme theme, so it loads with the first grid instead of in app.css on every page.
export const loadDevExtremeStyles = () => import(/* webpackChunkName: "datagrid" */ "../../app_css/datagrid.scss");
